import { createContext, useContext } from 'react';
import { noop } from '@ally/utilitarian';
/**
 * Creates an empty context with default values for testing purposes. Real
 * default values will be passed when the consumer renders the component and
 * is set when the Provider renders.
 */
export var MultiConsentContext = createContext({
    activeConsentIndex: 0,
    setActiveConsentIndex: noop,
    asyncStatus: 'None',
    setAsyncStatus: noop,
    showNextConsent: noop,
    focusIndex: 0,
    successByIndex: {},
});
export var useMultiConsent = function () {
    return useContext(MultiConsentContext);
};
//# sourceMappingURL=MultiConsentContext.js.map